module.exports = "/assets/data/325ae615027aea06c6b4434b429dc1af-IG8.data.json";